const nlTranslation = require('./nl.json')
const nlSurveyTranslation = require('./nlSurveys.json')

const newTranslation = { ...nlSurveyTranslation, ...nlTranslation }

export default newTranslation
